import api from "../../api";
import { recurringSummaryEndpoint } from "../../api/apisUrl";
import { apiError } from "../../models";
import {
  FETCH_PLAN_SUMMARY_LOADING,
  FETCH_PLAN_SUMMARY_SUCCESS,
  FETCH_PLAN_SUMMARY_FAILED,
} from "../types";

export const fetchPlanSummary =
  (planId: string, token: string) => async (dispatch: any) => {
    dispatch({ type: FETCH_PLAN_SUMMARY_LOADING });

    try {
      const response = await api.get(recurringSummaryEndpoint(planId), {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch({
        type: FETCH_PLAN_SUMMARY_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      apiError(
        FETCH_PLAN_SUMMARY_LOADING,
        FETCH_PLAN_SUMMARY_FAILED,
        error,
        dispatch
      );
    }
  };
